import { combineReducers } from 'redux'
import {
  MASTER_TARIF_PAGE_ERROR, MASTER_TARIF_PAGE_LOADING, MASTER_TARIF_LIST_SUCCESS,
  MASTER_TARIF_VIEW_SUCCESS, MASTER_TARIF_PAGE_SUCCESS, MASTER_TARIF_VIEW_ERROR,
  MASTER_TARIF_ADD_ERROR, MASTER_TARIF_ADD_LOADING, MASTER_TARIF_ADD_SUCCESS,
  MASTER_TARIF_VIEW_LOADING, MASTER_TARIF_DELETE_ERROR, MASTER_TARIF_DELETE_LOADING,
  MASTER_TARIF_DELETE_SUCCESS, MASTER_TARIF_UPDATE_SUCCESS, MASTER_TARIF_UPDATE_ERROR,
  MASTER_TARIF_UPDATE_LOADING, MASTER_TARIF_DELETE_TARIF_ERROR, MASTER_TARIF_DELETE_TARIF_LOADING,
  MASTER_TARIF_DELETE_TARIF_SUCCESS, MASTER_TARIF_ADD_TARIF_ERROR, MASTER_TARIF_ADD_TARIF_LOADING,
  MASTER_TARIF_ADD_TARIF_SUCCESS, MASTER_TARIF_UPDATE_RATES_ERROR, MASTER_TARIF_UPDATE_RATES_LOADING, MASTER_TARIF_UPDATE_RATES_SUCCESS, MASTER_TARIF_LIST_ERROR, MASTER_TARIF_LIST_LOADING
  , CATEGORY_TARIF_ERROR, CATEGORY_TARIF_LOADING, CATEGORY_TARIF_LIST_SUCCESS
} from './constant'
const categoryTarifPageError = (state = false, action) => {
  switch (action.type) {
    case CATEGORY_TARIF_ERROR:
      return action.categoryTarifListError
    default:
      return state
  }
}

const categoryTarifPageLoading = (state = false, action) => {
  switch (action.type) {
    case CATEGORY_TARIF_LOADING:
      return action.categoryTarifListLoading
    default:
      return state
  }
}

const categoryTarifPageSuccess = (state = false, action) => {
  switch (action.type) {
    case CATEGORY_TARIF_LIST_SUCCESS:
      return action.categoryTarifListSuccess
    default:
      return state
  }
}

const categoryTarifPageData = (state = false, action) => {
  switch (action.type) {
    case CATEGORY_TARIF_LIST_SUCCESS:
      return action.categoryTarif
    default:
      return state
  }
}

const masterTarifPageError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_PAGE_ERROR:
      return action.masterTarifPageError
    default:
      return state
  }
}

const masterTarifPageLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_PAGE_LOADING:
      return action.masterTarifPageLoading
    default:
      return state
  }
}

const masterTarifPageSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_PAGE_SUCCESS:
      return action.masterTarifPageSuccess
    default:
      return state
  }
}

const masterTarifs = (state = [], action) => {
  switch (action.type) {
    case MASTER_TARIF_PAGE_SUCCESS:
      return action.masterTarif
    // case MASTER_TARIF_LIST_SUCCESS:
    //   return action.masterTarif
    default:
      return state
  }
}

const masterTarif = (state = [], action) => {
  switch (action.type) {
    case MASTER_TARIF_VIEW_SUCCESS:
      return action.masterTarif
    default:
      return state
  }
}

const masterTarifAddError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_ERROR:
      return action.masterTarifAddError
    default:
      return state
  }
}

const masterTarifAddLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_LOADING:
      return action.masterTarifAddLoading
    default:
      return state
  }
}

const masterTarifAddSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_SUCCESS:
      return action.masterTarifAddSuccess
    default:
      return state
  }
}

const masterTarifViewError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_VIEW_ERROR:
      return action.masterTarifViewError
    default:
      return state
  }
}

const masterTarifViewLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_VIEW_LOADING:
      return action.masterTarifViewLoading
    default:
      return state
  }
}

const masterTarifViewSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_VIEW_SUCCESS:
      return action.masterTarifViewSuccess
    default:
      return state
  }
}

const masterTarifDeleteError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_ERROR:
      return action.masterTarifDeleteError
    default:
      return state
  }
}

const masterTarifDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_LOADING:
      return action.masterTarifDeleteLoading
    default:
      return state
  }
}

const masterTarifDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_SUCCESS:
      return action.masterTarifDeleteSuccess
    default:
      return state
  }
}

const masterTarifUpdateError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_ERROR:
      return action.masterTarifUpdateError
    default:
      return state
  }
}

const masterTarifUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_LOADING:
      return action.masterTarifUpdateLoading
    default:
      return state
  }
}

const masterTarifUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_SUCCESS:
      return action.masterTarifUpdateSuccess
    default:
      return state
  }
}

const masterTarifDeleteTarifError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_TARIF_ERROR:
      return action.masterTarifDeleteTarifError
    default:
      return state
  }
}

const masterTarifDeleteTarifLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_TARIF_LOADING:
      return action.masterTarifDeleteTarifLoading
    default:
      return state
  }
}

const masterTarifDeleteTarifSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_DELETE_TARIF_SUCCESS:
      return action.masterTarifDeleteTarifSuccess
    default:
      return state
  }
}

const masterTarifAddTarifError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_TARIF_ERROR:
      return action.masterTarifAddTarifError
    default:
      return state
  }
}

const masterTarifAddTarifLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_TARIF_LOADING:
      return action.masterTarifAddTarifLoading
    default:
      return state
  }
}

const masterTarifAddTarifSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_ADD_TARIF_SUCCESS:
      return action.masterTarifAddTarifSuccess
    default:
      return state
  }
}

const masterTarifUpdateRatesError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_RATES_ERROR:
      return action.masterTarifUpdateRatesError
    default:
      return state
  }
}

const masterTarifUpdateRatesLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_RATES_LOADING:
      return action.masterTarifUpdateRatesLoading
    default:
      return state
  }
}

const masterTarifUpdateRatesSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_UPDATE_RATES_SUCCESS:
      return action.masterTarifUpdateRatesSuccess
    default:
      return state
  }
}

const masterTarifListError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_LIST_ERROR:
      return action.masterTarifListError
    default:
      return state
  }
}

const masterTarifListLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_LIST_LOADING:
      return action.masterTarifListLoading
    default:
      return state
  }
}

const masterTarifListSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TARIF_LIST_SUCCESS:
      return action.masterTarifListSuccess
    default:
      return state
  }
}

const masterTarifListData = (state = [], action) => {
  switch (action.type) {
    case MASTER_TARIF_LIST_SUCCESS:
      return action.masterTarifListData
    default:
      return state
  }
}

const masterTarifReducer = combineReducers({
  masterTarifPageError,
  masterTarifPageLoading,
  masterTarifPageSuccess,

  masterTarifs,
  masterTarif,

  masterTarifAddError,
  masterTarifAddLoading,
  masterTarifAddSuccess,

  masterTarifViewError,
  masterTarifViewLoading,
  masterTarifViewSuccess,

  masterTarifDeleteError,
  masterTarifDeleteLoading,
  masterTarifDeleteSuccess,

  masterTarifUpdateError,
  masterTarifUpdateLoading,
  masterTarifUpdateSuccess,

  masterTarifDeleteTarifError,
  masterTarifDeleteTarifLoading,
  masterTarifDeleteTarifSuccess,

  masterTarifAddTarifError,
  masterTarifAddTarifLoading,
  masterTarifAddTarifSuccess,

  masterTarifUpdateRatesError,
  masterTarifUpdateRatesLoading,
  masterTarifUpdateRatesSuccess,

  masterTarifListError,
  masterTarifListLoading,
  masterTarifListSuccess,
  masterTarifListData,

  categoryTarifPageError,
  categoryTarifPageLoading,
  categoryTarifPageSuccess,
  categoryTarifPageData
})

export default masterTarifReducer
